import { storyblokEditable } from '@storyblok/react'
import { FC } from 'react'

import { renderField } from '@/components/03-organisms/Form/Blok'

interface FormRowProps {
  blok: any
}

const FormRow: FC<FormRowProps> = ({ blok }: { blok: any }) => {
  if (!blok.fields) return null

  return (
    <div
      {...storyblokEditable(blok)}
      className={`flex flex-col md:flex-row w-full md:*:w-1/2 gap-4 ${blok.fields && blok.fields.length === 1 ? 'pr-0 md:pr-4' : ''}`}
    >
      {blok.fields.map((field: any, index: any) => (
        <div key={index}>{renderField(field)}</div>
      ))}
    </div>
  )
}

export default FormRow
